import { createContext } from 'react';
import { QUERY_KEYS_CIHA, useChartsData } from '../../Common/hooks/useChartsData';
import { useCIHAFiltersContext } from '../../Common/Filters/hooks/useCIHAFiltersContext';

export const EpidemiologyChartsDataContext = createContext();

const EpidemiologyChartsDataProvider = ({ children }) => {
    const { filters } = useCIHAFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
        cnes: filters.unidade?.value,
        ano: filters.year?.value || currentYear,
        mes: filters.month?.value
    };

    const topMortalityCids = useChartsData(
        {
            key: QUERY_KEYS_CIHA.EPIDEMIOLOGY_TOP_MORTALITY_CIDS,
            url: 'governanceroom/cihadashboard/epidemiologyTopMortalityCids'
        },
        filterParams,
    
    );

    const epidemiologyMortalityEvolution = useChartsData(
        {
            key: QUERY_KEYS_CIHA.EPIDEMIOLOGY_MORTALITY_EVOLUTION,
            url: 'governanceroom/cihadashboard/epidemiologyMortalityEvolution'
        },
        filterParams,
        true
    );

    const epidemiologyByCidChapter = useChartsData(
        {
            key: QUERY_KEYS_CIHA.EPIDEMIOLOGY_BY_CID_CHAPTER,
            url: 'governanceroom/cihadashboard/epidemiologyByCidChapter'
        },
        filterParams,
    );

    const epidemiologyTopDiagnosis = useChartsData(
        {
            key: QUERY_KEYS_CIHA.EPIDEMIOLOGY_TOP_DIAGNOSIS,
            url: 'governanceroom/cihadashboard/epidemiologyTopDiagnosis'
        },
        filterParams,
    );


    const queries = [topMortalityCids, epidemiologyMortalityEvolution, epidemiologyByCidChapter, epidemiologyTopDiagnosis];
    const isLoading = queries.some((query) => query.isLoading);
    const isError = queries.some((query) => query.isError);
    
    const chartData = {
        topMortalityCids: topMortalityCids.data?.cids_maior_mortalidade|| [],
        epidemiologyMortalityEvolution: epidemiologyMortalityEvolution.data?.taxa_mortalidade_por_ano || [],
        epidemiologyByCidChapter: epidemiologyByCidChapter.data?.capitulos_cid || [],
        epidemiologyTopDiagnosis: epidemiologyTopDiagnosis.data?.top_diag_principal || []
    };
        
    return (
        <EpidemiologyChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters
            }}
        >
            {children}
        </EpidemiologyChartsDataContext.Provider>
    );
};

export default EpidemiologyChartsDataProvider;
